<template>
  <div class="user-section" v-bind="$attrs" v-on="$listeners">
    <div class="top sm d-flex flex-column bg-lightest-gray rounded">
      <span class="c-brand-color">
        {{ title }}
      </span>
      <h4 class="mt-1 text-wrap">
        {{ subtitle }}
      </h4>
    </div>
    <div class="bottom">
      <span>
        <i class="far fa-long-arrow-alt-right c-brand-color mr-2"></i>
        <span>
          {{ actionText }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HMUserSection',
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    actionText: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.user-section {
  border: 1px solid $medium-gray;
  border-radius: $border-radius;
  transition: all 0.2s ease-in-out;

  .top {
    padding: 1rem;
    min-height: 145px;
    border-radius: $border-radius;

    &.sm {
      min-height: inherit;
    }
  }

  .bottom {
    padding: 0.5rem 1rem;
  }

  &:hover {
    cursor: pointer;
    .bottom {
      background-color: var(--brand-color, $coral);
      color: white !important;

      span {
        i {
          color: white !important;
        }
      }
    }
  }

  @include media-breakpoint-down(md) {
    min-width: 100%;
    max-width: 100%;
    margin-top: 0.5rem;
  }
}
</style>
